angular.module('app').factory('categoryService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/category/");

        return {
            getTags: function (requestData) {
                return restAngular.
                    one("getTags").
                    customGET(param(requestData))
            },
            changeOrder: function (requestData) {
                return restAngular.
                    one("changeOrder").
                    post("", requestData)
            },
            changeItems: function (requestData) {
                return restAngular.
                one("changeItems").
                post("", requestData)
            }
        }
    }
]);